import { Route } from "react-router-dom";
import { RoutePathProps } from "../../../../AppRoutes/types";
import { addChildRoute } from "../../../../AppRoutes/utils";

import StoreIcon from '@mui/icons-material/Store';
import BadgeIcon from '@mui/icons-material/Badge';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import EmployeesList from "../pages/employee/EmployeesList";
import EmployeeDetail from "../pages/employee/EmployeeDetail";
import AddEditEmployee from "../pages/employee/AddEditEmployee";
import AttendanceList from "../pages/attendance/AttendanceList";
import AttendanceListPerMonthOneEmployee from "../pages/attendance/AttendanceListPerMonthOneEmployee";

const employee: RoutePathProps = {
  name: "employees",
  path: "employees",
  label: "Employees",
  visibleInNav: true,
  icon: BadgeIcon,
  requiredPermission: 'employee:list',
  children: [
    {
      name: "employeeDetail",
      path: ":id",
      label: "Employee Detail",
      icon: BadgeIcon,
      requiredPermission: 'employee:read'
    },
    {
      name: "addEmployee",
      path: "addEmployee",
      label: "Add Employee",
      icon: BadgeIcon,
      requiredPermission: 'employee:create'
    },
    {
      name: "editEmployee",
      path: "editEmployee/:id",
      label: "Edit Employee",
      icon: BadgeIcon,
      requiredPermission: 'employee:update'
    }
  ]
};

const attendance: RoutePathProps = {
  name: "attendance",
  path: "attendance",
  label: "Attendance",
  visibleInNav: true,
  icon: HowToRegIcon,
  requiredPermission: 'attendance:read',
  children: [
    {
      name: "attendanceListOneEmployee",
      path: ":id",
      label: "Attendance List One Employee",
      icon: HowToRegIcon,
      requiredPermission: 'attendance:check'
    },
    {
      name: "addAttendance",
      path: "addAttendance",
      label: "Add Attendance",
      icon: HowToRegIcon,
      requiredPermission: 'attendance:create'
    },
    {
      name: "editAttendance",
      path: "editAttendance/:id",
      label: "Edit Attendance",
      icon: HowToRegIcon,
      requiredPermission: 'attendance:update'
    }
  ]
};

const employeeManagement: RoutePathProps = (
  {
    name: "employeeManagement",
    path: "employeeManagement",
    label: "Employee Management",
    visibleInNav: true,
    icon: BadgeIcon,
    dummy: true,
    children: [employee, attendance],
    requiredPermission: 'employee:list',
  }
);

const shopManagement: RoutePathProps = addChildRoute(
  {
    name: "shopManagement",
    path: "/shopManagement",
    label: "Shop Management",
    visibleInNav: true,
    icon: StoreIcon,
    dummy: true,
    children: [employeeManagement],
    requiredPermission: 'employee:list',
  },
  { employeeManagement }
);

const ShopManagementRoutes = (
  <>
    {/* <Route path={shopManagement.path} element={<Vendor />} /> */}

    <Route path={shopManagement.path} element={<EmployeesList />} />
    <Route path={shopManagement.children?.[0].path} element={<EmployeesList />} />

    <Route path={shopManagement.children?.[0].children?.[0].path} element={<EmployeesList />} />
    <Route path={shopManagement.children?.[0].children?.[0].children?.[0].path} element={<EmployeeDetail />} />
    <Route path={shopManagement.children?.[0].children?.[0].children?.[1].path} element={<AddEditEmployee />} />
    <Route path={shopManagement.children?.[0].children?.[0].children?.[2].path} element={<AddEditEmployee />} />

    <Route path={shopManagement.children?.[0].children?.[1].path} element={<AttendanceList />} />
    <Route path={shopManagement.children?.[0].children?.[1].children?.[0].path} element={<AttendanceListPerMonthOneEmployee />} />

  </>
);

export const shopManagementPaths = [shopManagement];
export default ShopManagementRoutes;
